import { render, staticRenderFns } from "./ReFerees.vue?vue&type=template&id=eaa5c27a&"
import script from "./ReFerees.vue?vue&type=script&lang=js&"
export * from "./ReFerees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports